<section class="object">
  <div class="header">
    <h2>API Object Details</h2>
  </div>
  <div class="content">
    <mat-accordion class = "outer-accordian">
      <mat-expansion-panel class="page-details">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Page Details
          </mat-panel-title>
          <mat-panel-description>
            select or create page
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div>
          <!-- search webpages field -->
          <div>
            <form class="example-form">
              <input *ngIf="hideSearchBox" class="page-form" type="text" #box (keyup)="getValue(box.value)"
                placeholder="select an existing page or create a new one" [matAutocomplete]="auto" name="webpageSearch"
                [ngModel]="newApiObject.changedwebpageId" (ngModelChange)="searchWebPage($event)">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option (click)="displayobject(page)" *ngFor="let page of filterdWebPages" [value]="page.name">
                  {{page.name}}
                </mat-option>
                <a (click)="createPagebtn()" *ngIf="showCreateOption">
                  <mat-option>create new page with {{displayValue}}</mat-option>
                </a>
              </mat-autocomplete>
            </form>
          </div>
          <!-- create new page -->
          <div class="new" *ngIf="showModal=='createpageoption'">
            <span class="form__field">
              <input id="page__name" type="text" [(ngModel)]="newApiObject.wpname" name="PageName"
                matTooltipPosition="right" matTooltip="Page Name" class="form__input" placeholder="Page Name*">
            </span>
            <span class="form__field">
              <input id="page__url" type="text" [(ngModel)]="newApiObject.wpurl" name="URL" matTooltipPosition="right"
                matTooltip="URL" class="form__input" placeholder="URL">
            </span>
            <span class="form__field">
              <input id="page__description" type="text" [(ngModel)]="newApiObject.wpdesc" name="Description"
                matTooltipPosition="right" matTooltip="Description" class="form__input" placeholder="Description">
            </span>
            <!-- check box -->
            <mat-checkbox class="example-margin" [(ngModel)]="newApiObject.wpdefaultPage">Default to all
              objects</mat-checkbox>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- API Object Details Panel -->
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>API Request Details</mat-panel-title>
          <mat-panel-description>set API fields</mat-panel-description>
        </mat-expansion-panel-header>
        <div>
          <div class="details">
            <form #apiform="ngForm">
              <span class="form__field1">
                <input id="element__name" type="text" name="logical_name" [(ngModel)]="newApiObject.name"
                  matTooltipPosition="right" matTooltip="Name" required class="form__input" placeholder="Logical Name"
                  required #logicalNameInput="ngModel">
                <mat-error *ngIf="logicalNameInput.invalid && logicalNameInput.touched">Please enter a logical name</mat-error>
              </span>
              <br>
              <span class="form__field1" *ngIf="showModal=='selectWebPageOptions'">
                <input type="text" matTooltipPosition="right" matTooltip="Current Page" class="form__input"
                  name="webpage_name" [ngModel]="getcurrnetPageName(
                    newApiObject.webpageId.$oid
                    )?.name" disabled required>
              </span>
              
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>URL</mat-label>
                <input matInput [(ngModel)]="newApiObject.request.url.raw" name="url_raw"
                      required (ngModelChange)="onUrlChange(urlInput)" #urlInput="ngModel">
                <mat-error *ngIf="urlInput.invalid && urlInput.touched">Please enter a valid URL</mat-error>
              </mat-form-field>
  
              <!-- <div class="url-details">
                <p><strong>Protocol:</strong> {{ newApiObject.request.url.protocol }}</p>
                <p><strong>Host:</strong> {{ newApiObject.request.url.host }}</p>
                <p><strong>Port:</strong> {{ newApiObject.request.url.port }}</p>
                <p><strong>Path:</strong> {{ newApiObject.request.url.path }}</p>
              </div> -->
  
              <!-- api-request.component.html -->
              <mat-accordion class="scroll-accordian" multi >
  
                <!-- Query Parameters Panel -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Query Parameters</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <div *ngFor="let param of newApiObject.request.url.query_params; let i = index" class="param-row">
                    <mat-form-field appearance="fill">
                      <mat-label>Key</mat-label>
                      <input matInput [(ngModel)]="param.key" name="paramKey{{i}}" (ngModelChange)="updateRawUrlFromQueryParams()">
                    </mat-form-field>
  
                    <mat-form-field appearance="fill">
                      <mat-label>Value</mat-label>
                      <input matInput [(ngModel)]="param.value" name="paramValue{{i}}" (ngModelChange)="updateRawUrlFromQueryParams()">
                    </mat-form-field>
  
                    <button mat-icon-button color="warn" (click)="removeQueryParam(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
  
                  <button mat-button (click)="addQueryParam()" class="frmbtn">Add Parameter</button>
                </mat-expansion-panel>
  
                <!-- Headers Panel -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Headers</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <div *ngFor="let header of newApiObject.request.headers; let i = index" class="param-row">
                    <mat-checkbox [checked]="!header.disabled" (change)="header.disabled = !$event.checked" [name]="'headerDisabled' + i"></mat-checkbox>

                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Key</mat-label>
                      <div class="header-info">
                        <input matInput [disabled]="header.auto_generated" [(ngModel)]="header.key" name="headerKey{{i}}" [matTooltip]="getHeaderTooltip(header)">
                        <mat-icon *ngIf="header.auto_generated" matTooltip="This header is auto generated"
                          class="autogen-icon">
                          info
                        </mat-icon>
                      </div>
                    </mat-form-field>
  
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>Value</mat-label>
                      <input matInput [disabled]="header.auto_generated" [(ngModel)]="header.value" name="headerValue{{i}}" [matTooltip]="getHeaderTooltip(header)">
                    </mat-form-field>
  
                    <button mat-icon-button color="warn" [disabled]="header.auto_generated" (click)="removeHeader(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
  
                  <button mat-button (click)="addHeader()">Add Header</button>
                </mat-expansion-panel>
  
                <!-- Body Panel -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Body</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Body Type</mat-label>
                    <mat-select [(ngModel)]="newApiObject.request.body.mode" name="bodyMode" (selectionChange)="onBodyModeChange()">
                      <mat-option *ngFor="let mode of bodyModes" [value]="mode">{{ mode }}</mat-option>
                    </mat-select>
                  </mat-form-field>
  
                  <div *ngIf="newApiObject.request.body.mode === 'raw'">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-select [(ngModel)]="newApiObject.request.body.options.raw.language" name="raw_type" (selectionChange)="onBodyModeChange()">
                        <mat-option *ngFor="let type of rawLanguages" [value]="type">{{ type }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="fill" class="full-width">
                      <textarea matInput rows="10" #rawBodyTextArea="ngModel" [(ngModel)]="newApiObject.request.body.raw" name="raw_body" (ngModelChange)="validateRawBody(rawBodyTextArea)" class="textArea"></textarea>
                    </mat-form-field>
                  
                    <div *ngIf="rawBodyTextArea.invalid" class="error-message">
                      {{ rawValidationError }}
                    </div>
                  </div>                
  
                  <div *ngIf="newApiObject.request.body.mode === 'formdata'">
                    <div *ngFor="let item of newApiObject.request.body.formdata; let i = index" class="param-row">
                      <mat-form-field appearance="fill">
                        <mat-label>Key</mat-label>
                        <input matInput [(ngModel)]="item.key" name="formDataKey{{i}}">
                      </mat-form-field>
  
                      <mat-form-field appearance="fill">
                        <mat-label>Type</mat-label>
                        <mat-select [(ngModel)]="item.type" name="formDataType{{i}}">
                          <mat-option value="text">Text</mat-option>
                          <mat-option value="file">File</mat-option>
                        </mat-select>
                      </mat-form-field>
  
                      <mat-form-field appearance="fill" *ngIf="item.type === 'text'">
                        <mat-label>Value</mat-label>
                        <input matInput [(ngModel)]="item.value" name="formDataValue{{i}}">
                      </mat-form-field>
                      <div *ngIf="item.type === 'file'" class="file-input-group">
                        <div *ngFor="let filePath of item.src; let j = index" class="file-row">
                          <mat-form-field appearance="fill" class="file-path-field">
                            <mat-label>File Path</mat-label>
                            <input matInput [(ngModel)]="item.src[j]" name="formDataSrc{{i}}_{{j}}">
                          </mat-form-field>
                          <button mat-icon-button color="warn" (click)="removeFileInput(i, j)" *ngIf="item.src.length > 1">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                        <button mat-mini-button color="primary" (click)="addFileInput(i)">Add File</button>
                      </div>
                      <button mat-icon-button color="warn" (click)="removeFormDataParam(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <button mat-button (click)="addFormDataParam()">Add Form Data</button>
                  </div>
  
                  <div *ngIf="newApiObject.request.body.mode === 'urlencoded'">
                    <div *ngFor="let item of newApiObject.request.body.urlencoded; let i = index" class="param-row">
                      <mat-form-field appearance="fill">
                        <mat-label>Key</mat-label>
                        <input matInput [(ngModel)]="item.key" name="urlencodedKey{{i}}">
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Value</mat-label>
                        <input matInput [(ngModel)]="item.value" name="urlencodedValue{{i}}">
                      </mat-form-field>
                      <button mat-icon-button color="warn" (click)="removeUrlEncodedParam(i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                    <button mat-button (click)="addUrlEncodedParam()">Add URL Encoded</button>
                  </div>
  
                  <div *ngIf="newApiObject.request.body.mode === 'file'">
                    <mat-form-field appearance="fill" class="full-width">
                      <input matInput [(ngModel)]="newApiObject.request.body.file.src" placeholder="file link" name="bodyFileSrc">
                    </mat-form-field>
                  </div>
  
                  <div *ngIf="newApiObject.request.body.mode === 'graphql'">
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>GraphQL Query</mat-label>
                      <textarea matInput rows="5" [(ngModel)]="newApiObject.request.body.graphql.query" name="graphqlQuery"></textarea>
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="full-width">
                      <mat-label>GraphQL Variables</mat-label>
                      <textarea matInput rows="3" [(ngModel)]="newApiObject.request.body.graphql.variables" name="graphqlVars"></textarea>
                    </mat-form-field>
                  </div>
  
                </mat-expansion-panel>
  
                <!-- Authorization Panel -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Authorization</mat-panel-title>
                  </mat-expansion-panel-header>
  
                  <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Auth Type</mat-label>
                    <mat-select [(ngModel)]="newApiObject.request.auth.type" name="authType" (selectionChange)="onAuthChange()">
                      <mat-option *ngFor="let type of authTypes" [value]="type">{{ type }}</mat-option>
                    </mat-select>
                  </mat-form-field>
  
                  <ng-container [ngSwitch]="newApiObject.request.auth.type">
                    <!-- No Auth -->
                    <div *ngSwitchCase="'noauth'">
                      <p>No authentication required.</p>
                    </div>
  
                    <!-- API Key -->
                    <div *ngSwitchCase="'apikey'">
                      <mat-form-field appearance="fill">
                        <mat-label>Key</mat-label>
                        <input matInput placeholder="Key" #apikeyKeyInput="ngModel" [(ngModel)]="newApiObject.request.auth.apikey.key" name="apiKeyKey" required>
                        <mat-error *ngIf="apikeyKeyInput.invalid && apikeyKeyInput.touched">Please enter a apikey's key</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Value</mat-label>
                        <input matInput placeholder="Value" #apikeyValueInput="ngModel" [(ngModel)]="newApiObject.request.auth.apikey.value" name="apiKeyValue" required>
                        <mat-error *ngIf="apikeyValueInput.invalid && apikeyValueInput.touched">Please enter a apikey's value</mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>In</mat-label>
                        <mat-select [(ngModel)]="newApiObject.request.auth.apikey.in" name="apiKeyIn">
                          <mat-option value="header">Header</mat-option>
                          <mat-option value="query">Query Params</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
  
                    <!-- Bearer Token -->
                    <div *ngSwitchCase="'bearer'">
                      <mat-form-field appearance="fill" class="full-width">
                        <mat-label>Bearer Token</mat-label>
                        <input matInput placeholder="Token" #bearerTokenInput="ngModel" [(ngModel)]="newApiObject.request.auth.bearer.token" (ngModelChange)="onBearerTokenChange()" name="bearerToken" required>
                        <mat-error *ngIf="bearerTokenInput.invalid && bearerTokenInput.touched">Please enter a bearer token</mat-error>
                      </mat-form-field>
                    </div>
  
                    <!-- Basic Auth -->
                    <div *ngSwitchCase="'basic'">
                      <mat-form-field><mat-label>Username</mat-label><input matInput #basicAuthUsernameInput="ngModel" name="basicAuthUsername" placeholder="Username" [(ngModel)]="newApiObject.request.auth.basic.username" (ngModelChange)="onBasicAuthDataChange()" required></mat-form-field>
                      <mat-error *ngIf="basicAuthUsernameInput.invalid && basicAuthUsernameInput.touched">Please enter a username</mat-error>
                      <mat-form-field><mat-label>Password</mat-label><input matInput #basicAuthPasswordInput="ngModel" name="basicAuthPassword" type="password" placeholder="Password" [(ngModel)]="newApiObject.request.auth.basic.password" (ngModelChange)="onBasicAuthDataChange()" required></mat-form-field>
                      <mat-error *ngIf="basicAuthPasswordInput.invalid && basicAuthPasswordInput.touched">Please enter a password</mat-error>
                    </div>
  
                    <!-- OAuth1 -->
                    <div *ngSwitchCase="'oauth1'">
                      <mat-form-field><mat-label>Consumer Key</mat-label><input matInput name="oauth1ConsumerKey" placeholder="consumer Key" [(ngModel)]="newApiObject.request.auth.oauth1.consumerKey"></mat-form-field>
                      <mat-form-field><mat-label>Consumer Secret</mat-label><input matInput name="oauth1ConsumerSecret" placeholder="Consumer Secret" [(ngModel)]="newApiObject.request.auth.oauth1.consumerSecret"></mat-form-field>
                      <mat-form-field><mat-label>Token</mat-label><input matInput name="oauth1Token" placeholder="Token" [(ngModel)]="newApiObject.request.auth.oauth1.token"></mat-form-field>
                      <mat-form-field><mat-label>Token Secret</mat-label><input matInput name="oauth1TokenSecret" placeholder="Token Secret" [(ngModel)]="newApiObject.request.auth.oauth1.tokenSecret"></mat-form-field>
                      <mat-form-field><mat-label>Signature Method</mat-label><input matInput name="oauth1SignatureMethod" placeholder="Signature Method" [(ngModel)]="newApiObject.request.auth.oauth1.signatureMethod"></mat-form-field>
                      <mat-form-field><mat-label>Timestamp</mat-label><input matInput name="oauth1TimeStamp" placeholder="Timestamp" [(ngModel)]="newApiObject.request.auth.oauth1.timestamp"></mat-form-field>
                      <mat-form-field><mat-label>Nonce</mat-label><input matInput name="oauth1Nonce" placeholder="Nonce" [(ngModel)]="newApiObject.request.auth.oauth1.nonce"></mat-form-field>
                      <mat-form-field><mat-label>Version</mat-label><input matInput name="oauth1Version" placeholder="Version" [(ngModel)]="newApiObject.request.auth.oauth1.version"></mat-form-field>
                    </div>
  
                    <!-- OAuth2 -->
                    <div *ngSwitchCase="'oauth2'" class="oauth2-section" [attr.data-grant-type]="newApiObject.request.auth.oauth2.grant_type">
                      <div class="oauth2-main-form">

                        <mat-form-field appearance="fill">
                          <mat-label>Token</mat-label>
                          <input matInput placeholder="Token" #oauth2TokenInput="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.token" name="oauth2Token" required>
                          <mat-error *ngIf="oauth2TokenInput.invalid && oauth2TokenInput.touched">Please enter a oauth2 token</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                          <mat-label>Header Prefix</mat-label>
                          <input matInput placeholder="Header Prefix" #oauth2HeaderPrefix="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.headerPrefix" name="oauth2HeaderPrefix">
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                          <mat-label>Add authorization data to</mat-label>
                          <mat-select [(ngModel)]="newApiObject.request.auth.oauth2.addTokenTo" name="addOauth2TokenTo">
                            <mat-option value="header">Request Headers</mat-option>
                            <mat-option value="queryParams">Request URL</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>

                     <!-- <div class="oauth2-config-section">
                        <h2>Configure New Token</h2>
                        <div class="oauth2-form-grid">
                        <mat-form-field>
                          <mat-label>Token Name</mat-label>
                          <input matInput #oauth2TokenName="ngModel" placeholder="Token Name" [(ngModel)]="newApiObject.request.auth.oauth2.tokenName" name="oauth2tokenName">
                        </mat-form-field>
                        
                        <mat-form-field appearance="fill" class="full-width">
                          <mat-label>Grant Type</mat-label>
                          <mat-select #oauth2GrantType="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.grant_type" name="oauth2GrantType">
                            <mat-option value="implicit">Implicit</mat-option>
                            <mat-option value="authorization_code">Authorization Code</mat-option>
                            <mat-option value="authorization_code_with_pkce">Authorization Code (With PKCE)</mat-option>
                            <mat-option value="password_credentials">Password Credentials</mat-option>
                            <mat-option value="client_credentials">Client Credentials</mat-option>
                          </mat-select>
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'implicit' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'">
                          <mat-label>Callback URL</mat-label>
                          <input matInput 
                                #oauth2CallbackURL="ngModel" 
                                placeholder="Callback URL" 
                                [(ngModel)]="newApiObject.request.auth.oauth2.useBrowser ? '' : newApiObject.request.auth.oauth2.redirect_uri" 
                                name="oauth2CallbackURL"
                                [disabled]="newApiObject.request.auth.oauth2.useBrowser">
                        </mat-form-field>
                        
                        <div class="checkbox-field" *ngIf="newApiObject.request.auth.oauth2.grant_type === 'implicit' || 
                                                          newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                                          newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'">
                          <mat-checkbox #oauth2UseBrowser="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.useBrowser" name="oauth2UseBrowser">
                            Authorize using browser
                          </mat-checkbox>
                        </div>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'password_credentials' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'client_credentials'">
                          <mat-label>Access Token URL</mat-label>
                          <input matInput #oauth2AccessTokenURL="ngModel" placeholder="Access Token URL" [(ngModel)]="newApiObject.request.auth.oauth2.accessTokenUrl" name="oauth2AccessTokenURL">
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'implicit' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'">
                          <mat-label>Auth URL</mat-label>
                          <input matInput #oauth2AuthURL="ngModel" placeholder="Auth URL" [(ngModel)]="newApiObject.request.auth.oauth2.authUrl" name="oauth2AuthURL">
                        </mat-form-field>
                        
                        <mat-form-field>
                          <mat-label>Client Id</mat-label>
                          <input matInput #oauth2ClientId="ngModel" placeholder="Client Id" [(ngModel)]="newApiObject.request.auth.oauth2.clientId" name="oauth2ClientId">
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'password_credentials' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'client_credentials'">
                          <mat-label>Client Secret</mat-label>
                          <input matInput #oauth2ClientSecret="ngModel" placeholder="Client Secret" [(ngModel)]="newApiObject.request.auth.oauth2.clientSecret" name="oauth2ClientSecret">
                        </mat-form-field>
                        
                        <mat-form-field appearance="fill" *ngIf="newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'" class="full-width">
                          <mat-label>Code Challenge Method</mat-label>
                          <mat-select #oauth2CodeChallengeMethod="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.challengeAlgorithm" name="oauth2CodeChallengeMethod">
                            <mat-option value="S256">SHA-256</mat-option>
                            <mat-option value="plain">Plain</mat-option>
                          </mat-select>
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'">
                          <mat-label>Code Verifier</mat-label>
                          <input matInput placeholder="Code Verifier" #oauth2CodeVerifier="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.code_verifier" name="oauth2CodeVerifier">
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'password_credentials'">
                          <mat-label>Username</mat-label>
                          <input matInput placeholder="Username" #oauth2Username="ngModel" [(ngModel)]="newApiObject.request.auth.oauth2.username" name="oauth2Username">
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'password_credentials'">
                          <mat-label>Password</mat-label>
                          <input matInput type="password" #oauth2Password="ngModel" placeholder="Password" [(ngModel)]="newApiObject.request.auth.oauth2.password" name="oauth2Password">
                        </mat-form-field>
                        
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type !== 'implicit'">
                          <mat-label>Refresh Token URL</mat-label>
                          <input matInput #oauth2RefreshTokenURL="ngModel" placeholder="Refresh Token URL" [(ngModel)]="newApiObject.request.auth.oauth2.refreshTokenUrl" name="oauth2RefreshTokenURL">
                        </mat-form-field>
                        
                        <mat-form-field>
                          <mat-label>Add Token To</mat-label>
                          <input matInput #oauth2AddTokenTo="ngModel" placeholder="Add Token To" [(ngModel)]="newApiObject.request.auth.oauth2.addTokenTo" name="oauth2AddTokenTo">
                        </mat-form-field>

                        <mat-form-field>
                          <mat-label>Scope</mat-label>
                          <input matInput #oauth2Scope="ngModel" placeholder="Scope" [(ngModel)]="newApiObject.request.auth.oauth2.scope" name="oauth2Scope">
                        </mat-form-field>
                        <mat-form-field *ngIf="newApiObject.request.auth.oauth2.grant_type === 'implicit' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code' || 
                                              newApiObject.request.auth.oauth2.grant_type === 'authorization_code_with_pkce'">
                          <mat-label>State</mat-label>
                          <input matInput #oauth2State="ngModel" placeholder="State" [(ngModel)]="newApiObject.request.auth.oauth2.state" name="oauth2State">
                        </mat-form-field>
                        
                        <mat-form-field appearance="fill" class="full-width">
                          <mat-label>Client Authentication</mat-label>
                          <mat-select #oauth2ClientAuthentication="ngModel" placeholder="Client Authentication" [(ngModel)]="newApiObject.request.auth.oauth2.client_authentication" name="oauth2ClientAuthentication">
                            <mat-option value="header">Send as Basic Auth Header</mat-option>
                            <mat-option value="queryParams">Send client credentials in body</mat-option>
                          </mat-select>
                        </mat-form-field>
                        </div>
                      </div>               -->
                    </div>
  
                    <!-- NTLM -->
                    <div *ngSwitchCase="'ntlm'">
                      <mat-form-field><mat-label>Username</mat-label><input matInput placeholder="Username" [(ngModel)]="newApiObject.request.auth.ntlm.username"></mat-form-field>
                      <mat-form-field><mat-label>Password</mat-label><input matInput type="password" placeholder="Password" [(ngModel)]="newApiObject.request.auth.ntlm.password"></mat-form-field>
                      <mat-form-field><mat-label>Domain</mat-label><input matInput placeholder="Domain" [(ngModel)]="newApiObject.request.auth.ntlm.domain"></mat-form-field>
                      <mat-form-field><mat-label>Workstation</mat-label><input matInput placeholder="Workstation" [(ngModel)]="newApiObject.request.auth.ntlm.workstation"></mat-form-field>
                    </div>
  
                    <!-- Digest -->
                    <div *ngSwitchCase="'digest'">
                      <mat-form-field><mat-label>Username</mat-label><input matInput placeholder="placeholder" [(ngModel)]="newApiObject.request.auth.digest.username"></mat-form-field>
                      <mat-form-field><mat-label>Password</mat-label><input matInput type="password" placeholder="Password" [(ngModel)]="newApiObject.request.auth.digest.password"></mat-form-field>
                      <mat-form-field><mat-label>Realm</mat-label><input matInput placeholder="Realm" [(ngModel)]="newApiObject.request.auth.digest.realm"></mat-form-field>
                      <mat-form-field><mat-label>Nonce</mat-label><input matInput placeholder="Nonce" [(ngModel)]="newApiObject.request.auth.digest.nonce"></mat-form-field>
                      <mat-form-field><mat-label>Algorithm</mat-label><input matInput placeholder="Algorithm" [(ngModel)]="newApiObject.request.auth.digest.algorithm"></mat-form-field>
                      <mat-form-field><mat-label>QOP</mat-label><input matInput placeholder="QOP" [(ngModel)]="newApiObject.request.auth.digest.qop"></mat-form-field>
                    </div>
  
                    <!-- Hawk -->
                    <div *ngSwitchCase="'hawk'">
                      <mat-form-field><mat-label>ID</mat-label><input matInput placeholder="Id" [(ngModel)]="newApiObject.request.auth.hawk.id"></mat-form-field>
                      <mat-form-field><mat-label>Key</mat-label><input matInput placeholder="Key" [(ngModel)]="newApiObject.request.auth.hawk.key"></mat-form-field>
                      <mat-form-field><mat-label>Algorithm</mat-label><input matInput placeholder="Algorithm" [(ngModel)]="newApiObject.request.auth.hawk.algorithm"></mat-form-field>
                      <mat-form-field><mat-label>User</mat-label><input matInput placeholder="User" [(ngModel)]="newApiObject.request.auth.hawk.user"></mat-form-field>
                    </div>
  
                    <!-- AWS Signature -->
                    <div *ngSwitchCase="'awssigv4'">
                      <mat-form-field><mat-label>Access Key</mat-label><input matInput placeholder="Access Key" [(ngModel)]="newApiObject.request.auth.aws.accessKey"></mat-form-field>
                      <mat-form-field><mat-label>Secret Key</mat-label><input matInput placeholder="Secret Key" [(ngModel)]="newApiObject.request.auth.aws.secretKey"></mat-form-field>
                      <mat-form-field><mat-label>Region</mat-label><input matInput placeholder="Region" [(ngModel)]="newApiObject.request.auth.aws.region"></mat-form-field>
                      <mat-form-field><mat-label>Service Name</mat-label><input matInput placeholder="Service Name" [(ngModel)]="newApiObject.request.auth.aws.service"></mat-form-field>
                    </div>
  
                  </ng-container>
                </mat-expansion-panel>

                <!-- Validation Template Panel -->
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>Validation Template</mat-panel-title>
                  </mat-expansion-panel-header>
                  <p class="validation-template-hint">
                    Optional. Generated from a captured response via "Generate Validation Template"
                    in the API Response viewer, then saved here for reuse. Used as the Value 2 for
                    "validate response template" / "verify response matches template" steps.
                  </p>
                  <mat-form-field appearance="fill" class="full-width">
                    <textarea
                      matInput
                      rows="10"
                      spellcheck="false"
                      placeholder="No validation template saved yet for this API Object."
                      [(ngModel)]="newApiObject.validationTemplate"
                      name="validationTemplate"
                      class="textArea"
                    ></textarea>
                  </mat-form-field>
                </mat-expansion-panel>

              </mat-accordion>
            </form>

          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="modal-footer">
      <div class="bottom">
        <div class="btn">
          <button mat-button (click)="saveDialog()" cdkFocusInitial [featureActionState]="'API_TESTING'" [disabled]="apiform.invalid"> Save</button>
          <button class="cancel" mat-button (click)="onCloseClick()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</section>
